<template>
  <!-- <h1>editor</h1> -->
  <div id="editor">

    <div class="title">
      <label>输入课程名</label>
      <input type="text" placeholder="输入课程名" v-model="lessionName" >
    </div>

    <mavon-editor @htmlcode="true" style="height: 100%" @save="saveEditor" :value="initEditorValue"></mavon-editor>
  
  </div>
</template>

<script>
/* eslint-disable */
var mavonEditor = require('mavon-editor')
import 'mavon-editor/dist/css/index.css'
import { HYBIRD_URL } from '@/config/url_config'
import { ajaxAPI } from '@/utils/ajaxUtil'
// import 'mavon-editor/dist/js/hljs.javascript.js'
export default {
  components: {
    'mavon-editor': mavonEditor.mavonEditor
  },
  data () {
    return {
      lessionName: '',
      initEditorValue: "",
      accessToken: window.localStorage.getItem('accessToken')
    }
  },
  created () {
  },
  mounted () {
    console.log(this.$store.state.enterEditor)
    let enterEditor = this.$store.state.enterEditor
    if (enterEditor === 'n') {
      this.createCourse()      
    } else {
      let courseId = this.$store.state.courseId
      let url = `${HYBIRD_URL}/programming/room/teacherCourseInfo/api?courseId=${courseId}&access_token=${this.accessToken}`
      ajaxAPI('GET', url).then(data => {
        console.log(data)
        this.lessionName = data.data.data.courseName
        this.initEditorValue = data.data.data.courseContent
      })
    }
  },
  methods: {
    createCourse () {
      let url = `${HYBIRD_URL}/programming/room/teacherCourse/save/api?access_token=${this.accessToken}`
      let data = {
        roomId: this.$route.params.roomId,
        courseName: '标题',
        courseContent: ''
      }
      ajaxAPI('POST', url, data).then(data => {
        console.log(data)
        this.courseId = data.data.data.courseId
      })
    },
    editCourse () {
      this.courseId = this.$store.state.courseId
    },
    saveEditor (value, render) {
      // console.log(value)
      console.log('--------')
      console.log(this.$store.state.courseId)
      let courseId = this.$store.state.courseId
      let url = `${HYBIRD_URL}/programming/room/teacherCourse/update/api?access_token=${this.accessToken}`
      let data = {
        courseId: courseId,
        courseName: this.lessionName,
        courseContent: value
      }
      console.log(data)
      ajaxAPI('PUT', url, data).then(data => {
        console.log(data)
        this.$router.push({name: 'ClassRoom'})
      })
      this.lessionName = ''
    },
    htmlcode () {
      this.saveEditor()
      console.log('0000000')
    }
  }
}
</script>

<style lang="scss">
  .v-note-wrapper .v-note-panel .v-note-show .v-show-content, .v-note-wrapper .v-note-panel .v-note-show .v-show-content-html{
    background: #fff !important;
  }
  .code-github .hljs{
    background: #e5e5e5 !important;
  }
  #editor {
    margin: auto;
    width: 100%;
    height: 580px;
    .save{
      width: 200px;
      height: 50px;
    }
    .title{
      text-align: center;
    }
    input{
      width: 200px;
      height: 28px;
      margin: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// editor.vue?a6112144